'use strict';

import SearchSwitchTriple from "../components/SearchSwitchTriple";
import Loading from "../components/Loading";
import SearchRoutes from "../components/SearchRoutes";
import SearchFilterBlockWithTooltip from "../components/ui/search/SearchFilterBlockWithTooltip";
import Sort from "../components/ui/search/Sort";
import StickyContainer from "../components/ui/search/StickyContainer";
import Filters from "../components/search/Filters";
import NoItems from "../components/ui/search/NoItems";
import SearchRouteStub from "../components/ui/search/SearchRouteStub";
import SearchListItem from "../components/ui/search/SearchListItem";
import {getAircraftsCompared, hasAircraftCompared, isAircraftComparedFlightInitiator, switchAircraftCompared} from "../helpers/aircraftCompare";
import ScrollTarget from "../components/ScrollTarget";
import Tooltip from "../components/ui/tooltip/Tooltip";
import { createRoutesValidator } from "../helpers/validators";
import {queryGetActualSearchData} from "../helpers/search";
import { useSearchFilters, withSearchFiltersHook } from "../hooks/useSearchFilters";
import { withSearchSortHook } from "../hooks/useSearchSort";
import Switch from "../components/ui/filter/Switch";
import EventsSlider from "../components/search/EventsSlider";

const IMAGE_DIMENSIONS = {
    LIST: '260x160',
    DETAIL: '550x360',
}
const MAX_AIRPORTS = 8

class SearchPageContainer extends React.Component {
    
    constructor(props) {
        super(props);

        this.abortController = new AbortController();
        this.state = {
            isClassesFetching: false,
            isRelatedDataFetching: false,
            isAircraftBarometerLoaded: false,
            
            isPlanesFetching: false,
            isSeatsFetching: false,
            isToursFetching: false,
            searchPerformed: false,

            // Заглушка вместо выдачи по самолётам для маршрутов из/в РФ
            routeStub: null,

            // При переходе на таб места или туры, скролится к указанному месту
            seatsAnchor: null,
            toursCountry: null,

            // from fetch initial data
            airports: [],
            classes: [],
            
            // from fetch search items
            planes: [],
            seats: [],
            tours: [],
            barometer_aircrafts: [],
            
            // from fetch additional data
            hotels: [],
            main_events: [],
            events: [],
            barometer: {},

            // Всякие ошибки
            classes_error: null,
            search_error: null,
            related_data_error: null,

            // Указанные данные в поиске, фильтре, сортировке
            selected_routes: this.getDefaultRoutes(),
            selected_filters: [],
            selected_sort: 'price:asc',
            
            stickyProps: { isSticky: false, wrapHeight: 0, containerHeight: 0, stickyTop: 0 },
            isRoutesOpened: false,

            aircrafts_compared: [],
        }

        this.routesRef = React.createRef();
        this.contentRef = React.createRef();
        this.resultsRef = React.createRef();
        
        this.handleReloadDelayed = _.debounce(this.reloadData.bind(this), 1000);
        this.handleNoItemsSetErrors = this.handleNoItemsSetErrors.bind(this);
        
        this.routesValidator = createRoutesValidator();
    }

    componentDidMount() {
        this.fetchInitData()
        
        this.setInitRoutes().then(r => {
            this.reloadData()
        });
        
        listenEvent('react.aircraftComparedAdded', () => this.updateAircraftsCompared())
        listenEvent('react.aircraftComparedRemoved', () => this.updateAircraftsCompared())
    }

    async setInitRoutes() {

        const querySearchData = await queryGetActualSearchData(true)
        const reactSearchData = storageGetActualSearchData();

        if (querySearchData && querySearchData.length > 0) {
            return new Promise(resolve => {
                this.setState({
                    selected_routes: querySearchData,
                }, resolve);
            })
        } else {
            const searchOnMount = Object.keys(reactSearchData).length > 0;
            if (searchOnMount) {
                return new Promise(resolve => {
                    this.setLinksData(reactSearchData.routesPlane);
                    this.setState({
                        selected_routes: reactSearchData.routesPlane || this.getDefaultRoutes(),
                    }, resolve);   
                });
            }
        }
    }

    fetchInitData() {
        this.setInitialLoaders()
        
        this.fetchAirports()
        this.fetchAircraftClasses()
    }
    
    setInitialLoaders() {
        this.setState({
            isClassesFetching: true,
        })
    }
    
    fetchAirports() {
        requestAction.initData(true, MAX_AIRPORTS).then(response => {
            this.setState({
                airports: response.airports,
            })
        })
    }
    
    fetchAircraftClasses() {
        this.setState({
            isClassesFetching: true,
            classes: [],
            classes_error: null,
        })
        searchAction.fetchAircraftClasses()
            .then((result) => this.setState({classes: result}))
            .catch((result) => {
                console.error(result)
                this.setState({classes_error: tMsg('Классы самолета недоступны')})
            })
            .finally((result) => this.setState({isClassesFetching: false}))
    }
    
    fetchRelatedData() {

        const routes = this.getRoutesFormData()
        
        this.setState({
            isRelatedDataFetching: true,
            hotels: [],
            main_events: [],
            events: [],
            barometer: {},
            related_data_error: null,
        })
        
        searchAction.fetchSearchRelatedData({routes})
            .then((result) => this.setState({
                hotels: result.hotels || [],
                main_events: result.main_events || [],
                events: result.events || [],
                barometer: result.barometer || {},
            }))
            .catch((result) => {
                console.error(result)
                this.setState({classes_error: tMsg('Произошла ошибка при загрузке данных')})
            })
            .finally((result) => this.setState({isRelatedDataFetching: false}))
    }
    
    fetchBarometer() {
        const routes = this.getRoutesFormData()
        const aircrafts = this.getAircrafts()
        
        this.setState({
            isAircraftBarometerLoaded: false,
            barometer_aircrafts: [],
        });
        
        searchAction.fetchAircraftsBarometer({ routes, aircrafts })
            .then((result) => {
                this.setState({
                    barometer_aircrafts: result,
                })
            })
            .catch((error) => {
                console.error(error)
                this.setState({related_data_error: tMsg('Произошла ошибка при загрузке данных')})
            })
            .finally(() => {
                this.setState({isAircraftBarometerLoaded: true})
            })
    }
    
    getAircrafts() {
        return this.state.planes
            .map(item => item.aircraft.id)
            .reduce((a, c) => {
                if (!a.includes(c)) {
                    a.push(c)
                }
                
                return a
            }, [])
    }

    handleSearch() {

        const { searchFilters } = this.props;
        const {selected_routes, seatsAnchor, toursCountry} = this.state;

        this.routesValidator.validate(selected_routes);
        this.setState({route_error: this.routesValidator.errors})
        if (this.routesValidator.hasErrors) return;

        storageRemove('reactSearchData');
        storageSet('reactSearchData', {routesPlane: selected_routes, seatsAnchor, toursCountry})

        this.resetSearchResults();
        this.setState({isPlanesFetching: true, isSeatsFetching: true, isToursFetching: true, search_error: null, searchPerformed: true, isRoutesOpened: true});
        this.abortController.abort();
        this.abortController = new AbortController();
        const abortSignal = this.abortController.signal;

        const requestUUID = uuidv4()
        const fetch = (type, routes, abortSignal) => {
            return new Promise((resolve, reject) => {
                searchAction.fetchStream({
                    onSources: (response, request) => {
                        if (request.type === 'planes') {
                            this.setState({routeStub: response.stub || null})
                        }
                    },
                    onData: ({items, payload}, request) => {
                        this.setState((state) => {
                            const currentItems = [...state[request.type]].filter(e => e._cursor !== request.id);

                            for (const item of items) {
                                const found = currentItems.find(e => e.id === item.id)
                                if (found) continue
                                currentItems.push({...item, _cursor: request.id})
                            }

                            if (request.type === 'planes') {
                                searchFilters.recountFilters(currentItems)
                            }
                            
                            return {
                                [request.type]: currentItems,
                            }
                        })
                    },
                    onError: (error) => {
                        this.setState({search_error: tMsg('Произошла ошибка при загрузке данных')});
                        console.error(error.message)
                        return reject();
                    },
                    onClose: (cancelled) => {
                        if (cancelled)
                            return reject();

                        this.setState(_ => {
                        }, resolve); // Чтобы выполнилось только после записи в стэйт последнего фетча
                    },
                    abortSignal,
                }, {version: 'v2', type, routes, uuid: requestUUID})

            })
        }

        const promises = []
        promises.push(
            fetch('planes', selected_routes, abortSignal)
                .then(() => {
                    const newItems = this.combineEqualItems(this.state.planes || [])
                    searchFilters.recountFilters(newItems)
                    this.setState({ planes: newItems })
                    searchAction.saveStatistics({uuid: requestUUID, type: 'planes', results_count: newItems.length, routes: selected_routes});
                })
                .finally(() => !abortSignal.aborted && this.setState({isPlanesFetching: false}))
            ,
            fetch('seats', selected_routes, abortSignal)
                .then(() => {
                })
                .finally(() => {
                    if (abortSignal.aborted) return;
                    this.setState({isSeatsFetching: false})
                    this.setSeatsCount();
                })
            ,
            fetch('tours', selected_routes, abortSignal)
                .then(() => {
                })
                .finally(() => {
                    if (abortSignal.aborted) return;
                    this.setState({isToursFetching: false})
                    this.setToursCount();
                })
        )

        Promise.allSettled(promises)
            .then(() => {
                this.setStorageAfter()
            })
            .then(() => {
                this.fetchRelatedData()
            })
            .then(() => {
                this.fetchBarometer()
            })
    }

    resetSearchResults()
    {
        const { searchFilters } = this.props;
        searchFilters.resetFilters();
        
        this.setState ( {
            planes: [],
            seats: [],
            tours: [],
            hotels: [],
            main_events: [],
            events: [],
            barometer: {},
            barometer_aircrafts: [],
            search_error: null,
            related_data_error: null,
            routeStub: null,
        } )
    }

    combineEqualItems(items = []) {

        // Если одинаковые equality_key, то берем тот, у кого цена меньше

        const filteredItems = [];

        items.map((item) => {

            const index = filteredItems.findIndex((e) => e.equality_key === item.equality_key);

            // Если нет equality_key или еще нет элемента в массиве
            if (!item.equality_key || index === -1) {
                filteredItems.push(item);
                return;
            }

            // Если цена нового элемента меньше - заменяем
            if (filteredItems[index].prices.price_sort > item.prices.price_sort)
                filteredItems.splice(index, 1, item);
        });

        return filteredItems;
    }

    getPlanesFilteredSorted() {
        const { planes: items } = this.state
        
        const { 
            searchFilters: { filterItems },
            searchSort: { sortItems },
        } = this.props;
        
        const filteredItems = filterItems(items, this.state.selected_filters)
        return sortItems(filteredItems, this.state.selected_sort)
    }
    
    scrollTop(speed = 600) {
        this.routesRef.current.scroll(speed);
    }
    
    reloadData() {
        this.scrollTop()
        this.handleSearch()
    }
    
    getSelectedSort() {
        const {selected_sort} = this.state
        return selected_sort
    }

    setSelectedSort(value) {
        this.setState({
            selected_sort: value
        })
    }
    
    handleFiltersSelectedChange(values = {}) {
        // todo Данные будут Загружаться еще раз, когда подгрузятся фильтры
        this.setState({
            selected_filters: values,
        })
    }

    setLinksData(routes) {
        
        if (!routes && !Array.isArray(routes)) return;
            
        const seatsAnchor = [parseInt(routes[0]['from']['city_id']), parseInt(routes[0]['to']['city_id'])]
            .filter(e => e)
            .sort((a, b) => a - b)
            .join('-');
        const toursCountry = routes[0]['to']['country_id'] || null;

        this.setState({
            seatsAnchor: seatsAnchor,
            toursCountry: toursCountry,
        })
    }

    setStorageAfter() {
        const {selected_routes, planes, seats, tours} = this.state;

        storageSet('reactSearchData', {
            routesPlane: selected_routes,

            seatsAnchor: this.state.seatsAnchor,
            toursCountry: this.state.toursCountry,

            planesCount: planes.length,
            seatsCount: seats.length,
            toursCount: tours.length,
        })
    }

    setSeatsCount() {
        storageAdd('reactSearchData', {
            seatsCount: (this.state.seats || []).length,
        })
    }

    setToursCount() {
        storageAdd('reactSearchData', {
            toursCount: (this.state.tours || []).length,
        })
    }
    
    hasBarometer() {
        const { barometer, isAircraftBarometerLoaded } = this.state
        return isAircraftBarometerLoaded && Object.keys(barometer).length > 0
    }
    
    getBarometerByAircraftId(id) {
        const { barometer_aircrafts } = this.state
        return barometer_aircrafts.find(e => e.aircraft.id == id)
    }

    getBarometerAveragePrice(id) {
        const barometer = this.getBarometerByAircraftId(id)
        return barometer ? barometer.average_price : null;
    }
    
    getDefaultRoutes() {
        return [{
            from: {},
            to: {},
            date: '',
            time: '',
            seats: 0,
        }]
    }
    
    isSelectedRoutesCompleted() {
        const {selected_routes} = this.state
        return (selected_routes || []).every(({from, to, date, time, seats}) => {
            return from && from.id && from.type
                && to && to.id && to.type
                && !!date && !!time && !!seats
        })
    }
    
    getRoutesFormData() {
        const {selected_routes} = this.state
        return JSON.stringify(this.getDefaultRoutes()) === JSON.stringify(selected_routes)
            ? []
            : selected_routes
    }

    handleChangeRoutes(routes) {
        this.scrollTop()
        this.state.show_route_errors = false;
        this.setState({selected_routes: routes})
        this.setLinksData(routes)
    }

    handleSearchClick() {
        this.reloadData()
    }
    
    getRoutes() {
        const {selected_routes} = this.state
        return selected_routes
    }

    handleStickyChange({ isSticky, wrapHeight, containerHeight, stickyTop }) {
        this.setState({
            stickyProps: { isSticky, wrapHeight, containerHeight, stickyTop }
        })
    }
    
    handleWatchThePriceClick() {
        // todo чо делать?
        console.log('yes subscribe me')
    }

    getRequestLink() {
        return '/request/plane?from_search=1';
    }

    isItemInCompare(id) {
        return hasAircraftCompared(id)
    }

    isItemCompareInitiator(aircraft_id, flight_id) {
        return isAircraftComparedFlightInitiator(aircraft_id, flight_id)
    }
    
    handleCompareClick({aircraft, id}) {
        switchAircraftCompared({...aircraft, initiator_id: id})
        this.updateAircraftsCompared()
    }

    updateAircraftsCompared() {
        this.setState({aircrafts_compared: getAircraftsCompared()})
    }

    onRoutesFocus() {
        this.scrollTop()
    }

    handleNoItemsSetErrors() {
        this.setState({ show_route_errors: this.routesValidator.hasErrors });
        this.scrollTop(300);
    }
    
    handleIsOpenedChange(value) {
        this.scrollTop()
        this.setState({ isRoutesOpened: value });
    }
    
    isRoutesStickable() {
        return this.getRoutes().length === 1 || !this.state.isRoutesOpened 
    }
    
    getIsRoutesFull() {
        return !this.routesValidator.hasErrors;
    }
    
    handleItemClick(item) {
        const {selected_routes} = this.state
        const barometer = {
            averagePrice: this.getBarometerAveragePrice(item.aircraft_compare.id),
            onShowBarometerClick: () => this.handleShowBarometerClick(item.aircraft.id),
        }
        $.fancybox.open({
            src: '#reactFlightSearchModal',
            afterShow: () => {
                raiseEvent('react.selectFlightOffer', {
                    item, 
                    barometer, 
                    showForm: item.is_emptyleg,
                    routes: selected_routes, 
                    imageDimensions: IMAGE_DIMENSIONS.DETAIL
                });
            },
            afterClose: () => {
                raiseEvent('react.selectFlightOffer', {item: null, barometer: null});
            }
        })
    }

    handleShowCompareClick() {
        $.fancybox.open({
            src: '#reactAircraftCompareModal',
            props: {
                tab: this.state.aircrafts_compared.length > 0 ? 'models' : 'classes',
            },
            afterShow: () => {
                raiseEvent('react.openCompareAircraft', {});
            },
            afterClose: () => {
                raiseEvent('react.openCompareAircraft', {});
            }
        })
    }
    
    handleShowBarometerClick(aircraft_id = null) {
        
        const {barometer, selected_routes} = this.state
        
        const routes_transformed = []
        selected_routes.map((r, index) => {
            if (index === 0 || !(r.from.id === selected_routes[index-1].to.id && r.from.type === selected_routes[index-1].to.type)) {
                routes_transformed.push({
                    icao: r.from.icao,
                    title: r.from.title
                })
            }
            routes_transformed.push({
                icao: r.to.icao,
                title: r.to.title
            })
        })

        const aircraft = this.getBarometerByAircraftId(aircraft_id)
        
        $.fancybox.open({
            src: '#reactBarometerModal',
            props: {
                tab: aircraft ? 'aircraft' : 'classes',
            },
            afterShow: () => {
                raiseEvent('react.openBarometer', {routes: routes_transformed, classes: barometer, aircraft: aircraft});
            },
            afterClose: () => {
                raiseEvent('react.openBarometer', {routes: [], classes: [], aircraft: null});
            }
        })
    }
    
    handleOnlyEmptyLegsFilterChange(enabled) {
        const { selected_filters } = this.state
        let newValues = selected_filters
        if (enabled) {
            newValues = { ...selected_filters, is_emptyleg: enabled ? '1' : undefined }
        } else if ('is_emptyleg' in selected_filters) {
            delete selected_filters['is_emptyleg']
        }
        
        this.setState({
            selected_filters: newValues
        })
    }

    render() {
        const {isPlanesFetching, searchPerformed, isAircraftBarometerLoaded} = this.state
        const {airports, selected_filters, classes, planes, seats, tours, hotels, main_events, events, aircrafts_compared, barometer} = this.state
        const {search_error, classes_error, show_route_errors, route_error, routeStub} = this.state
        const {stickyProps: {wrapHeight}} = this.state

        const isRouteFull = this.getIsRoutesFull()
        const showStub = !isPlanesFetching && searchPerformed && !!routeStub
        const showNoItems = !isPlanesFetching && searchPerformed && !routeStub && (search_error || planes.length === 0)
        const showRouteErrors = showNoItems && searchPerformed && show_route_errors

        const { 
            searchFilters: { filterFilters, loading: isFiltersFetching, error: filtersError },
            searchSort: { sort }
        } = this.props;
        const filters = filterFilters(selected_filters)
        const emptylegFilterIndex = filters.findIndex(e => 'is_emptyleg' === e.id)
        const emptylegFilter = emptylegFilterIndex >= 0 ? filters.splice(emptylegFilterIndex, 1)[0] : null

        const displayPlanes = this.getPlanesFilteredSorted()
        
        return <div className="container2">
            <div className="planes-search">
                <div className="planes-search__title">
                    {tMsg('Поиск лучших цен')}
                </div>

                <SearchSwitchTriple
                    type={'planes'}
                    planesCount={planes.length}
                    seatsCount={seats.length}
                    toursCount={tours.length}
                    setSearchScenario={searchPerformed}
                />
                
                <ScrollTarget offsetDown={-30} offsetUp={-100} ref={this.routesRef} />
               

                <StickyContainer isStickable={this.isRoutesStickable()} stickyPadding={20} onChange={data => this.handleStickyChange(data)}>

                    <SearchRoutes
                        type={'planes'}
                        routes={this.getRoutes()}
                        airports={airports}
                        maxRoutes={5}
                        dropDownParent={'.search'}
                        onlyAirports={true}
                        maxAirports={8}
                        errors={showRouteErrors ? route_error : undefined}
                        isOpenedInit={!searchPerformed}
                        onIsOpenedChange={(value) => this.handleIsOpenedChange(value)}
                        onFocus={() => this.onRoutesFocus()}
                        onChangeRoutes={(routes) => this.handleChangeRoutes(routes)}
                        onSearch={(routes) => this.handleSearchClick(routes)}
                    />

                    <div className="el-sorting">
                        <div className="el-sorting__row">

                            {isPlanesFetching && <div className="el-sorting__count">
                                <div className="progress-bar">
                                    <div className="progress-bar-text">
                                        {tMsg('Ищем самолеты...')}
                                    </div>
                                    <span className="progress-bar-inner" style={{width:"30%"}}></span>
                                </div>
                            </div>}

                            {!isPlanesFetching && !routeStub && <div className="el-sorting__count">
                                {`${displayPlanes.length} ${plural(displayPlanes.length, tMsg("предложение|предложения|предложений"))}`}
                            </div>}

                            <Sort items={sort} value={this.getSelectedSort()}
                                  onChange={(value) => this.setSelectedSort(value)}/>

                            <div className="el-sorting__control">
                                <div className="el-sorting__graph">
                                    {!routeStub && isAircraftBarometerLoaded && barometer && barometer.items && barometer.items.length > 0 && <a role='button' className="el-sorting__graph-link"
                                        onClick={() => this.handleShowBarometerClick()}>
                                        <i className="icon-graph"></i>
                                        <span>{tMsg('График цен')}</span>
                                    </a>}
                                </div>
                                <div className="el-sorting__compare">
                                    <a role='button' className="el-sorting__compare-link" onClick={() => this.handleShowCompareClick()}>
                                        <i className="icon-compare2"></i>
                                        {aircrafts_compared.length > 0 && <b style={{display: 'inline'}}>
                                            {aircrafts_compared.length}
                                        </b>}
                                        <span>{tMsg('Сравнение')}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </StickyContainer>


                <div className="el-row">

                    <div className={cn(
                        'el-sidebar', 
                        this.isRoutesStickable() && this.getRoutes().length === 1 && 'el-sidebar_with-padding_big', 
                        this.isRoutesStickable() && this.getRoutes().length > 1 && 'el-sidebar_with-padding_small'
                    )}>

                        <EventsSlider items={ main_events } />

                        {/* Пока нет функционала */}
                        {false && this.isSelectedRoutesCompleted() && <SearchFilterBlockWithTooltip
                            title={'Следить за ценой'}
                            tooltip_title={'Будем рассказывать про самые выгодные самолеты в этом поиске'}
                            onClick={this.handleWatchThePriceClick}
                        />}

                        {emptylegFilter && <div className="el-sidebar__item el-sidebar__single">
                            <Switch title={tMsg('Только Empty Legs')}
                                    checked={selected_filters.is_emptyleg}
                                    disabled={isFiltersFetching || emptylegFilter.values.find(e => e.id === '1').count === 0}
                                    onChange={enabled => this.handleOnlyEmptyLegsFilterChange(enabled)}
                            />
                        </div>}

                        <div className="el-sidebar__item">
                            <Filters
                                filters={filters}
                                values={selected_filters}
                                isLoading={isFiltersFetching}
                                error={filtersError}
                                onChange={(values) => this.handleFiltersSelectedChange(values)}
                            />
                        </div>

                    </div>


                    <div ref={this.contentRef} className="el-content">

                        <ScrollTarget ref={this.resultsRef} offset={-90 - (wrapHeight || 0)} className="results">

                            {showStub && <SearchRouteStub
                                type={routeStub.type}
                                contacts={routeStub.contacts}
                            />}

                            {showNoItems && <NoItems
                                title={search_error || undefined}
                                button={tMsg('Оставить заявку')}
                                link={isRouteFull ? this.getRequestLink() : undefined}
                                onClick={isRouteFull ? undefined : this.handleNoItemsSetErrors}
                            />}

                            {!showStub && (displayPlanes || []).map((item) => {
                                return <SearchListItem
                                    key={`items${item.id}`}
                                    item={{...item, routes: []}}
                                    imageSize={IMAGE_DIMENSIONS.LIST}
                                    showPriceModal={this.hasBarometer()}
                                    averagePrice={this.getBarometerAveragePrice(item.aircraft_compare.id)}
                                    isInCompare={this.isItemInCompare(item.aircraft_compare.id)}
                                    isCompareInitiator={this.isItemCompareInitiator(item.aircraft_compare.id, item.id)}
                                    onClick={(id) => this.handleItemClick(item)}
                                    onCompareClick={() => this.handleCompareClick({aircraft: item.aircraft_compare, id: item.id})}
                                    onShowBarometerClick={() => this.handleShowBarometerClick(item.aircraft.id)}
                                />
                            })}

                            {<Loading active={isPlanesFetching} absolute={false} style={{
                                borderTop: '3px solid #e9e9e9',
                                borderLeft: '3px solid #e9e9e9',
                                borderRight: '3px solid #e9e9e9'
                            }}/>}

                        </ScrollTarget>

                        <div className="el__events">

                            {hotels.slice(0, 1).map(({id, title, price, image, icon, link}) => {
                                return <div key={`hotels${id}`} className="event-card">
                                    <a href={link} className="event-card__link"></a>
                                    <div className="event-card__img">
                                        <img width={226} height={160} src={image} alt="" style={{objectFit:'cover'}}/>
                                    </div>
                                    <div className="event-card__title">
                                        <div>
                                            <h3>{title}</h3>
                                            <div className="event-card__title-info">
                                                <i className={icon}></i>
                                                {price}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}

                            {events.slice(0, 3).map(({id, title, date, image, flag, link}) => {
                                return <div key={`events${id}`} className="event-card">
                                    <a href={link} className="event-card__link"></a>
                                    <div className="event-card__img">
                                        <img width={226} height={160} src={image || ''} alt="" style={{objectFit:'cover'}}/>
                                    </div>
                                    <div className="event-card__title">
                                        <div>
                                            <h3>{title}</h3>
                                            <span>{date}</span>
                                        </div>
                                        {flag && <div className="event-card__flag">
                                            <img src={flag} alt=""/>
                                        </div>}
                                    </div>
                                </div>
                            })}

                        </div>
                    </div>
                </div>
            </div>
            
            <Tooltip />
        </div>
    }
}

const domContainer = document.querySelector('#reactSearchPageContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(
    withSearchFiltersHook(
        withSearchSortHook(
            SearchPageContainer,
        ),
        { enableIsEmptylegFilter: true }
    )
));